import { Component, OnInit } from '@angular/core';

import { Router, ActivatedRoute } from '@angular/router';

import { Subscription } from 'rxjs/Subscription';

import { DomainsService } from './domains.service';
import { NotificationService } from '../../../core/services/notification.service';
import { ConfigService } from '../../../core/services/config.service';

@Component({
  selector: 'itpx-domains',
  templateUrl: './domains.component.html',
  styleUrls: ['./domains.component.css']
})
export class DomainsComponent implements OnInit {

    private details: any = {};
    private id: string;
    private sub: Subscription;
    private interfaces: Array<any>;
    private dataReceived: string = 'no';
    private deliverables: any;

    constructor(
        private service: DomainsService,
        private notificationService: NotificationService,
        private configService: ConfigService,
        private route: ActivatedRoute,
        private router: Router
    ) { }

    ngOnInit() {
        this.sub = this.route.params.subscribe(params => {
            this.updateData();
        });
    }

    updateData() {
        this.service.getDomain(this.details.id)
            .subscribe(data => this.extractData(data));
    }

    makeDefault(domainNameId: string) {
        this.service.makeDomainNameDefault(domainNameId)
            .subscribe(data => this.updateData());
    }

    ngOnDestroy() {
        this.sub.unsubscribe();
    }

    private extractData(body: any) {
        this.details = <any>body.data;
        this.dataReceived = 'yes';
    }

    private handleSuccess(error: any) {
        this.router.navigate(['organization/domains']);
    }

    navigateToAddName() {
      this.router.navigate(['organization/domains/add-name/:id', {id: this.details.id}]);
    }

}



// WEBPACK FOOTER //
// ./src/app/organization/components/domains/domains.component.ts